module.exports = __webpack_public_path__ + "static/img/97.8587df5.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/97.png
// module id = 445
// module chunks = 1 2 3 4 5 6 7 8